import React, { useState } from 'react';
import className from 'classnames';
import config from 'react-global-configuration';
import { push } from 'connected-react-router';
import { useDispatch } from 'react-redux';

import ApiAutocomplete from '../../../components/ApiAutocomplete';
import {
  Select,
  Form,
} from '../../../components';

const AwardsForm = () => {
  const API_URL = config.get('API_URL');
  const dispatch = useDispatch();
  const [year, setYear] = useState(new Date().getFullYear() - 1);
  const [locality, setLocality] = useState('');

  const years = [];
  years.push({ label: '- Geen voorkeur -' });
  for (let year = new Date().getFullYear(); year >= 2015; year--) {
    years.push({ value: year, label: year });
  }

  const onSubmit = () => {
    dispatch(push(`/toekenningen/programma?year=${year}&locality=${locality}`));
  };

  return (
    <div className="AwardsForm">
      <Form onSubmit={(e) => { e.preventDefault(); onSubmit(); }}>
        <div className="Form__element">
          <label htmlFor="locality">Plaatsnaam</label>
          <ApiAutocomplete
            name="locality"
            id="locality"
            endpoint={`${API_URL}/api/autocomplete`}
            placeholder="Zoek op plaatsnaam"
            onSelectItem={(item) => {
              setLocality(item.name);
            }}
            renderItem={(item, active) => {
              const classes = className({
                active: active,
              });
              return (
                <div className={classes}>
                  {item.name}
                  {item.type === 'gemeente'
                    && <> (Gemeente)</>}
                </div>
              );
            }}
          />
        </div>
        <div className="Form__element">
          <label htmlFor="year">Jaar</label>
          <Select
            name="year"
            id="year"
            handleChange={(option) => {
              setYear(option.value);
            }}
            defaultValue={{ value: new Date().getFullYear() - 1, label: `${new Date().getFullYear() - 1}` }}
            options={years}
          />
        </div>
        <button type="submit">Bekijk toekenningen</button>
      </Form>
    </div>
  );
};

export default AwardsForm;
